import api from './api';

const emailService = {
  // Pobierz aktualną konfigurację email
  getConfig: async () => {
    const response = await api.get('/email/config');
    return response.data;
  },

  // Zapisz nową konfigurację email
  saveConfig: async (configData) => {
    const response = await api.post('/email/config', configData);
    return response.data;
  },

  // Testuj konfigurację SMTP
  testConnection: async () => {
    const response = await api.post('/email/test');
    return response.data;
  },

  // Wyślij testowy email
  sendTestEmail: async (to) => {
    const response = await api.post('/email/send-test', { to });
    return response.data;
  },

  // Wyślij dane logowania nowemu użytkownikowi
  sendLoginCredentials: async (userData) => {
    const response = await api.post('/email/send-login-credentials', { userData });
    return response.data;
  },

  // Wyślij powiadomienie o nowych uprawnieniach
  sendPermissions: async (userData, folderAccess) => {
    const response = await api.post('/email/send-permissions', { userData, folderAccess });
    return response.data;
  }
};

export default emailService;
